/* global INTENTO_API_HOST INTENTO_API_KEY INTENTO_CONSOLE_URL */
import axios from 'axios'

import {
    track,
    APP_NAME,
    APP_VERSION,
    getCookieValue,
    getMarkedCookieValue,
} from 'utils'

// for ie 11 for msoffice add-ins support
require('es6-promise').polyfill()

function getSignedRequestParams(data) {
    // TODO use middleware to sign each request

    const params = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Xsrftoken': getCookieValue('_xsrf'), // TODO fix missing cookie
        },
    }

    if (process.env.REACT_APP_API_VERSION) {
        params.headers['X-api-version'] = process.env.REACT_APP_API_VERSION
    }

    if (data) {
        params.data = data
    }

    const token = localStorage.getItem('token')

    if (token) {
        params.headers.Authorization = `Bearer ${token}`
    }

    return params
}

async function getResponse(config, errorReportData) {
    try {
        const response = await axios(config)
        return response.data
    } catch (e) {
        track('service failure', errorReportData)
        throw e
    }
}

async function support(data) {
    const requestOptions = getSignedRequestParams(data)
    const url = '/api/support'

    return getResponse({ url, ...requestOptions }, { url, ...data })
}

async function apidocsFromElastic(params) {
    const { slug } = params
    const data = {
        id: slug,
        type: 'api',
    }
    const requestOptions = getSignedRequestParams(data)
    const url = `/api/apidoc`

    return getResponse({ url, ...requestOptions }, { url, slug })
}

async function requestAPI(params, method) {
    const { slug, data } = params
    let url = `https://${INTENTO_API_HOST}/${slug}`
    let apikey = INTENTO_API_KEY
    const production = getMarkedCookieValue('IPK')
    let logs = {}

    if (production) {
        apikey = production
    }

    const config = {
        url,
        method,
        headers: {
            apikey,
            'x-user-agent': `${APP_NAME}/${APP_VERSION}`,
        },
        data,
    }

    const token = getMarkedCookieValue('UAT')

    if (token && !production) {
        config.url = `${INTENTO_CONSOLE_URL}/api/${slug}`
        config.headers.Authorization = `Bearer ${token}`
        delete config.headers['x-user-agent']
        delete config.headers.apikey
    }

    if (data) {
        try {
            logs = {
                provider: data.service.provider,
                from: data.context.from,
                to: data.context.to,
            }
        } catch (err) {} // eslint-disable-line no-empty
    }

    const res = await getResponse(config, {
        url,
        slug,
        isProduction: Boolean(production),
        ...logs,
    })

    return res
}

async function postRequestAPI(params) {
    return requestAPI(params, 'POST')
}

async function getRequestAPI(params) {
    return requestAPI(params, 'GET')
}

async function getProvider({ intent, id }) {
    return getRequestAPI({ slug: `${intent}/${id}` })
}

async function getIntentProviders(slug) {
    // without apidoc description
    return getRequestAPI({ slug })
}

async function getIntentLanguages(intent) {
    return getRequestAPI({ slug: `${intent}/languages` })
}

async function providersFromAPI(providers) {
    return Promise.all(
        providers.map(async p => {
            const pFull = await getProvider(p)
            return { intent: p.intent, ...pFull }
        })
    )
}

async function getNews() {
    const response = await axios(
        'https://api.rss2json.com/v1/api.json?rss_url=https://blog.inten.to/feed'
    )
    const data = response.data || {}
    // Filter for acctual posts. Comments don't have categories, therefore can filter for items with categories bigger than 0
    const res = data.items || [] // This is an array with the content. No feed, no info about author etc..
    const posts = res.filter(item => item.categories.length > 0) // That's the main trick* !
    return posts
}

export default {
    support,
    postRequestAPI,
    apidocsFromElastic,
    getProvider,
    getIntentProviders,
    getIntentLanguages,
    providersFromAPI,
    getNews,
}



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/connectors/redux/services/index.js